(() => {
  if (window.__jhnyGiftExperienceLoaded) return;
  window.__jhnyGiftExperienceLoaded = true;

  document.querySelectorAll("[data-jhny-gift-root]").forEach((root) => {
    const dialog = root.querySelector("[data-jhny-gift-dialog]");
    const frame = root.querySelector("[data-jhny-gift-frame]");
    const trigger = root.querySelector("[data-jhny-gift-open]");
    const close = root.querySelector("[data-jhny-gift-close]");
    if (!dialog || !frame || !trigger) return;

    const section = root.closest('[id^="shopify-section-"]') || root.parentElement;
    const productForms = () => Array.from(section.querySelectorAll('form[action*="/cart/add"]'));
    const submitButtons = () => productForms().flatMap((form) => Array.from(form.querySelectorAll('[type="submit"]')));
    const selectedVariant = () => productForms().map((form) => form.querySelector('[name="id"]')?.value).find(Boolean) || "";

    const setLocked = (locked) => {
      submitButtons().forEach((button) => {
        button.disabled = locked;
        button.setAttribute("aria-disabled", String(locked));
      });
      root.dataset.ready = locked ? "false" : "true";
    };

    const selectAmountVariant = (amount) => {
      let map = {};
      try { map = JSON.parse(root.dataset.variantMap || "{}"); } catch { map = {}; }
      const variantId = map[String(amount)];
      if (!variantId) return false;
      productForms().forEach((form) => {
        const input = form.querySelector('[name="id"]');
        if (!input) return;
        input.value = String(variantId);
        input.dispatchEvent(new Event("change", { bubbles: true }));
      });
      return true;
    };

    const setGiftReference = (giftId) => {
      productForms().forEach((form) => {
        let input = form.querySelector('input[name="properties[_gift_experience_id]"]');
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "properties[_gift_experience_id]";
          form.appendChild(input);
        }
        input.value = giftId;
      });
      trigger.querySelector("strong").textContent = "Personal gift ready";
      root.querySelector(".jhny-gift-required").textContent = "Your private gift details are ready.";
      setLocked(false);
    };

    const addGiftToCart = (giftId, amount) => {
      if (!selectAmountVariant(amount)) return;
      setGiftReference(giftId);
      const form = productForms().find((candidate) => candidate.querySelector('[name="id"]'));
      dialog.close();
      if (!form) return;
      window.setTimeout(() => {
        if (typeof form.requestSubmit === "function") form.requestSubmit();
        else form.submit();
      }, 120);
    };

    setLocked(true);
    trigger.addEventListener("click", () => {
      const base = root.dataset.appUrl?.replace(/\/$/, "");
      if (!base) return;
      const url = new URL(`${base}/embed`);
      const variant = selectedVariant();
      if (variant) url.searchParams.set("variant", variant);
      frame.src = url.toString();
      dialog.showModal();
    });
    close?.addEventListener("click", () => dialog.close());
    dialog.addEventListener("click", (event) => { if (event.target === dialog) dialog.close(); });

    window.addEventListener("message", (event) => {
      const base = root.dataset.appUrl;
      if (!base || event.origin !== new URL(base).origin || !event.data) return;
      if (event.data.type === "jhny:gift-add-to-cart" && event.data.giftId) {
        addGiftToCart(event.data.giftId, event.data.amount);
      }
      if (event.data.type === "jhny:gift-close") dialog.close();
    });
  });
})();

